module.exports = __webpack_public_path__ + "img/icon_black_parking.ed22cb79.svg";